import { put, call, takeLatest } from 'redux-saga/effects'
import services from '../../services'

import {
  GET_ALL_CONTENTS_STATICS,
  GET_ALL_CONTENTS_STATICS_ERROR,
  GET_ALL_CONTENTS_STATICS_SUCCESS,
  GetAllContentsStatics,
} from '../types/statics/get-all-content'

import {
  GET_ALL_GEOLOCATIONS_STATICS,
  GET_ALL_GEOLOCATIONS_STATICS_ERROR,
  GET_ALL_GEOLOCATIONS_STATICS_SUCCESS,
  GetAllGeolocationsStatics,
} from '../types/statics/get-all-geolocations'

import {
  GET_ALL_CUSTOMERS_STATICS,
  GET_ALL_CUSTOMERS_STATICS_ERROR,
  GET_ALL_CUSTOMERS_STATICS_SUCCESS,
  GetAllCustomersStatics,
} from '../types/statics/get-all-customers'

import {
  GET_ALL_USERS_STATICS,
  GET_ALL_USERS_STATICS_ERROR,
  GET_ALL_USERS_STATICS_SUCCESS,
  GetAllUsersStatics,
} from '../types/statics/get-all-users'

import {
  GET_ALL_RESPONSIBLES_STATICS,
  GET_ALL_RESPONSIBLES_STATICS_ERROR,
  GET_ALL_RESPONSIBLES_STATICS_SUCCESS,
  GetAllResponsiblesStatics,
} from '../types/statics/get-all-responsibles'




function* getAllContentsStatics() {
  try {
    const { response, error } = yield call(services.statics.getAllContentsStatics)
    if (error) {
      yield put({
        type: GET_ALL_CONTENTS_STATICS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_CONTENTS_STATICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_CONTENTS_STATICS_ERROR,
      payload: 'Error al obtener contenido estatico',
    })
  }
}

function* getAllGeolocations() {
  try {
    const { response, error } = yield call(services.statics.getAllGeolocations)
    if (error) {
      yield put({
        type: GET_ALL_GEOLOCATIONS_STATICS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_GEOLOCATIONS_STATICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_GEOLOCATIONS_STATICS_ERROR,
      payload: 'Error al obtener información de geolocalización',
    })
  }
}

function* getAllCustomers({ payload }) {
  try {
    const { response, error } = yield call(services.statics.getAllCustomers, payload)
    if (error) {
      yield put({
        type: GET_ALL_CUSTOMERS_STATICS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_CUSTOMERS_STATICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_CUSTOMERS_STATICS_ERROR,
      payload: 'Error al obtener clientes',
    })
  }
}

function* getAllUsers() {
  try {
    const { response, error } = yield call(services.statics.getAllUsers)
    if (error) {
      yield put({
        type: GET_ALL_USERS_STATICS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_USERS_STATICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_USERS_STATICS_ERROR,
      payload: 'Error al obtener usuarios',
    })
  }
}

function* getAllResponsibles() {
  try {
    const { response, error } = yield call(services.statics.getAllResponsibles)
    if (error) {
      yield put({
        type: GET_ALL_RESPONSIBLES_STATICS_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ALL_RESPONSIBLES_STATICS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_RESPONSIBLES_STATICS_ERROR,
      payload: 'Error al obtener responsables',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetAllContentsStatics>(GET_ALL_CONTENTS_STATICS, getAllContentsStatics)
  yield takeLatest<GetAllGeolocationsStatics>(GET_ALL_GEOLOCATIONS_STATICS, getAllGeolocations)
  yield takeLatest<GetAllCustomersStatics>(GET_ALL_CUSTOMERS_STATICS, getAllCustomers)
  yield takeLatest<GetAllUsersStatics>(GET_ALL_USERS_STATICS, getAllUsers)
  yield takeLatest<GetAllResponsiblesStatics>(GET_ALL_RESPONSIBLES_STATICS, getAllResponsibles)

}
